module.exports = __webpack_public_path__ + "static/iltasanomat05012008kuva2.a8b9e4a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iltasanomat05012008kuva2.jpg
// module id = 824
// module chunks = 129563053867776